var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterMesh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1923.37 1099.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{opacity:0.7;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:url(#linear-gradient);}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{clip-path:url(#clip-path-4);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{clip-path:url(#clip-path-5);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{clip-path:url(#clip-path-6);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{clip-path:url(#clip-path-7);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{clip-path:url(#clip-path-8);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{clip-path:url(#clip-path-9);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{clip-path:url(#clip-path-10);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{clip-path:url(#clip-path-11);}.cls-24{fill:url(#linear-gradient-11);}.cls-25{clip-path:url(#clip-path-12);}.cls-26{fill:url(#linear-gradient-12);}.cls-27{clip-path:url(#clip-path-13);}.cls-28{fill:url(#linear-gradient-13);}.cls-29{clip-path:url(#clip-path-14);}.cls-30{fill:url(#linear-gradient-14);}.cls-31{clip-path:url(#clip-path-15);}.cls-32{fill:url(#linear-gradient-15);}.cls-33{clip-path:url(#clip-path-16);}.cls-34{fill:url(#linear-gradient-16);}.cls-35{clip-path:url(#clip-path-17);}.cls-36{fill:url(#linear-gradient-17);}.cls-37{clip-path:url(#clip-path-18);}.cls-38{fill:url(#linear-gradient-18);}.cls-39{clip-path:url(#clip-path-19);}.cls-40{fill:url(#linear-gradient-19);}.cls-41{clip-path:url(#clip-path-20);}.cls-42{fill:url(#linear-gradient-20);}.cls-43{clip-path:url(#clip-path-21);}.cls-44{fill:url(#linear-gradient-21);}.cls-45{clip-path:url(#clip-path-22);}.cls-46{fill:url(#linear-gradient-22);}.cls-47{clip-path:url(#clip-path-23);}.cls-48{fill:url(#linear-gradient-23);}.cls-49{clip-path:url(#clip-path-24);}.cls-50{fill:url(#linear-gradient-24);}.cls-51{clip-path:url(#clip-path-25);}.cls-52{fill:url(#linear-gradient-25);}.cls-53{clip-path:url(#clip-path-26);}.cls-54{fill:url(#linear-gradient-26);}.cls-55{clip-path:url(#clip-path-27);}.cls-56{fill:url(#linear-gradient-27);}.cls-57{clip-path:url(#clip-path-28);}.cls-58{fill:url(#linear-gradient-28);}.cls-59{clip-path:url(#clip-path-29);}.cls-60{fill:url(#linear-gradient-29);}.cls-61{clip-path:url(#clip-path-30);}.cls-62{fill:url(#linear-gradient-30);}.cls-63{clip-path:url(#clip-path-31);}.cls-64{fill:url(#linear-gradient-31);}.cls-65{clip-path:url(#clip-path-32);}.cls-66{fill:url(#linear-gradient-32);}.cls-67{clip-path:url(#clip-path-33);}.cls-68{fill:url(#linear-gradient-33);}.cls-69{clip-path:url(#clip-path-34);}.cls-70{fill:url(#linear-gradient-34);}.cls-71{clip-path:url(#clip-path-35);}.cls-72{fill:url(#linear-gradient-35);}.cls-73{clip-path:url(#clip-path-36);}.cls-74{fill:url(#linear-gradient-36);}.cls-75{clip-path:url(#clip-path-37);}.cls-76{fill:url(#linear-gradient-37);}.cls-77{clip-path:url(#clip-path-38);}.cls-78{fill:url(#linear-gradient-38);}.cls-79{clip-path:url(#clip-path-39);}.cls-80{fill:url(#linear-gradient-39);}.cls-81{clip-path:url(#clip-path-40);}.cls-82{fill:url(#linear-gradient-40);}.cls-83{clip-path:url(#clip-path-41);}.cls-84{fill:url(#linear-gradient-41);}.cls-85{clip-path:url(#clip-path-42);}.cls-86{fill:url(#linear-gradient-42);}.cls-87{clip-path:url(#clip-path-43);}.cls-88{fill:url(#linear-gradient-43);}.cls-89{clip-path:url(#clip-path-44);}.cls-90{fill:url(#linear-gradient-44);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.05,0C49.34,57.77,23.66,114.08,28.4,163.44,35.83,240.83,118,301.71,372.76,325.72,555.08,339.9,625,375.22,630.16,426.49c5.91,59.12-74.66,138.9-168.53,231.86-128.09,126.85-281,278.27-272.39,433.9q.19,3.42.45,6.82H189c-.17-2.33-.33-4.66-.46-7-8.66-156.43,144.42-308,272.66-435,93.68-92.78,174.09-172.4,168.27-230.63-5-50.37-74.76-85.16-256.58-99.31C117.65,303.07,35.23,241.59,27.72,163.38,23,113.74,48.36,57.58,78.92,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 490.15,
    y1: 1082.93,
    x2: 136.23,
    y2: -92.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a1877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.69,0C63.13,67.07,28.05,133.33,33.52,190.33,41,267.72,123.16,328.6,377.88,352.61c182.32,14.18,252.28,49.5,257.4,100.76,5.91,59.13-74.66,138.91-168.53,231.87C344.17,806.63,198.89,950.52,194.16,1099.07h-.71C198,949.71,343.54,805.55,466.33,684,560,591.17,640.42,511.55,634.6,453.32,629.57,403,559.84,368.16,378,354,122.77,330,40.35,268.48,32.84,190.27,27.34,132.93,62.09,66.88,98.54,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 494.51,
    y1: 1081.62,
    x2: 140.58,
    y2: -93.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.44,0q-5.62,10.43-11.33,20.85C70.4,90,33,158.51,38.65,217.22,46.08,294.6,128.28,355.49,383,379.49,565.32,393.68,635.28,429,640.4,480.26c5.91,59.13-74.66,138.91-168.53,231.87-115.17,114-250.37,248-270.22,386.94h-.76C220.54,959.34,356,825.12,471.45,710.84c93.69-92.78,174.09-172.4,168.28-230.63-5-50.37-74.76-85.16-256.59-99.31C127.89,356.85,45.48,295.37,38,217.16,32.26,157.76,69.76,89,107.58,19.7Q113,9.86,118.3,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 499.11,
    y1: 1080.23,
    x2: 145.19,
    y2: -94.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.81,0c-8.19,15.87-16.89,31.82-25.58,47.74C75.52,116.87,38.13,185.4,43.77,244.11c7.43,77.38,89.63,138.27,344.35,162.27,182.32,14.19,252.29,49.51,257.41,100.77C651.43,566.28,570.86,646.06,477,739c-107.72,106.67-233,230.73-265,360h-.83C243,969,368.59,844.66,476.57,737.72,570.26,645,650.66,565.33,644.85,507.1c-5-50.38-74.76-85.16-256.59-99.31C133,383.74,50.6,322.26,43.09,244,37.38,184.65,74.88,115.92,112.7,46.59c8.48-15.53,17-31.1,25-46.59Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 503.81,
    y1: 1078.82,
    x2: 149.88,
    y2: -96.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.29,0C145.6,24.68,132,49.69,118.35,74.62,80.64,143.76,43.25,212.29,48.89,271c7.43,77.38,89.63,138.27,344.35,162.27C575.56,447.46,645.53,482.78,650.65,534,656.55,593.16,576,673,482.11,765.91c-100.23,99.26-215.65,213.56-257,333.16h-.9c41.18-120.25,157-234.91,257.47-334.46C575.38,671.84,655.78,592.22,650,534c-5-50.38-74.76-85.16-256.59-99.31C138.13,410.62,55.72,349.15,48.21,270.93,42.5,211.54,80,142.81,117.82,73.48c13.4-24.55,26.84-49.19,38.4-73.48Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 508.5,
    y1: 1077.4,
    x2: 154.58,
    y2: -97.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.35,0C160.69,33.29,142,67.48,123.47,101.51,85.76,170.65,48.37,239.18,54,297.89c7.43,77.38,89.63,138.27,344.35,162.27,182.33,14.19,252.29,49.51,257.41,100.77,5.9,59.13-74.66,138.91-168.54,231.87-92.69,91.79-198.36,196.46-246.43,306.27h-1c48-110.44,154-215.47,247-307.57,93.68-92.77,174.09-172.39,168.27-230.62-5-50.38-74.76-85.16-256.59-99.31C143.25,437.51,60.84,376,53.33,297.82c-5.71-59.39,31.79-128.12,69.61-197.45C141.31,66.7,159.76,32.89,173.35,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 513.2,
    y1: 1075.99,
    x2: 159.27,
    y2: -99.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.38,0c-13.44,41.62-37.18,85.13-60.79,128.4-37.71,69.13-75.1,137.67-69.46,196.38C66.56,402.16,148.76,463,403.48,487.05c182.33,14.19,252.29,49.51,257.41,100.77,5.9,59.12-74.66,138.91-168.54,231.87C407.26,904,311.22,999.08,258.86,1099.07h-1.09C310.09,998.49,406.52,903,491.94,818.39,585.62,725.62,666,646,660.21,587.77c-5-50.38-74.76-85.16-256.59-99.31C148.37,464.4,66,402.93,58.45,324.71c-5.7-59.39,31.79-128.12,69.62-197.45C151.48,84.34,175,41.18,188.48,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 517.89,
    y1: 1074.58,
    x2: 163.97,
    y2: -100.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.7,0c-10.3,49.55-39.23,102.6-68,155.29C96,224.42,58.61,293,64.25,351.67c7.43,77.38,89.63,138.26,344.36,162.27C590.93,528.13,660.89,563.45,666,614.71c5.91,59.12-74.66,138.91-168.53,231.87C420,923.26,333.55,1008.93,279.14,1099.07H278c54.42-90.71,141.33-176.77,219.1-253.79,93.68-92.77,174.09-172.4,168.27-230.62-5-50.38-74.76-85.16-256.59-99.31C153.5,491.29,71.08,429.82,63.57,351.6c-5.7-59.39,31.79-128.12,69.62-197.45C161.76,101.77,190.51,49.06,200.9,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 522.59,
    y1: 1073.16,
    x2: 168.67,
    y2: -102.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.5,0c-3.36,57-37.64,119.82-71.66,182.18-37.72,69.13-75.11,137.66-69.47,196.37C76.8,455.94,159,516.83,413.73,540.83,596.05,555,666,590.34,671.13,641.6,677,700.72,596.47,780.51,502.6,873.47c-69.7,69-146.74,145.31-201.11,225.6h-1.28c54.46-80.83,131.92-157.53,202-226.9,93.68-92.77,174.09-172.4,168.27-230.62-5-50.38-74.76-85.16-256.58-99.31C158.62,518.18,76.2,456.71,68.69,378.49,63,319.1,100.48,250.37,138.31,181c33.87-62.09,68-124.66,71.48-181Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 527.28,
    y1: 1071.75,
    x2: 173.36,
    y2: -103.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.73,0V0c8.52,63.72-31.31,136.71-70.77,209.05-37.72,69.13-75.1,137.66-69.47,196.37,7.44,77.39,89.64,138.27,344.36,162.28,182.32,14.19,252.28,49.5,257.4,100.77,5.91,59.12-74.66,138.9-168.53,231.87-61.87,61.26-129.53,128.27-182,198.71h-1.37c52.61-71,120.7-138.38,182.93-200C601,806.29,681.39,726.66,675.57,668.43c-5-50.37-74.76-85.15-256.58-99.31-255.25-24-337.66-85.52-345.18-163.74-5.7-59.39,31.8-128.12,69.62-197.45C182.78,135.81,222.48,63,214.06.06V0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 531.98,
    y1: 1070.33,
    x2: 178.06,
    y2: -104.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.34,0a201.92,201.92,0,0,1,5.51,26.9c8.52,63.73-31.3,136.72-70.77,209.06C111.37,305.09,74,373.62,79.61,432.33,87.05,509.72,169.25,570.6,424,594.61c182.32,14.19,252.29,49.5,257.4,100.77,5.91,59.12-74.66,138.9-168.53,231.86-54,53.43-112.3,111.21-161.13,171.83h-1.44C399.32,1038,458.1,979.74,512.42,926c93.69-92.78,174.09-172.4,168.28-230.63-5-50.37-74.77-85.16-256.59-99.31C168.86,572,86.45,510.48,78.93,432.27c-5.7-59.39,31.8-128.12,69.62-197.45,39.35-72.13,79-144.9,70.63-207.87A199.27,199.27,0,0,0,213.64,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 536.68,
    y1: 1068.92,
    x2: 182.75,
    y2: -106.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.1,0A209.13,209.13,0,0,1,225,53.79c8.52,63.73-31.3,136.72-70.77,209.06C116.49,332,79.1,400.51,84.74,459.22c7.43,77.39,89.63,138.27,344.35,162.28C611.41,635.69,681.38,671,686.5,722.27c5.9,59.12-74.67,138.9-168.54,231.86-45.91,45.47-95,94.1-138.72,144.94h-1.52c44-51.33,93.53-100.38,139.82-146.23,93.69-92.78,174.09-172.4,168.28-230.63-5-50.37-74.76-85.15-256.59-99.3C174,598.85,91.57,537.37,84.06,459.16,78.35,399.77,115.85,331,153.67,261.7,193,189.58,232.72,116.81,224.3,53.84A207.15,207.15,0,0,0,209.31,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 541.37,
    y1: 1067.5,
    x2: 187.45,
    y2: -107.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.89,0c14.33,25.13,24.35,51.86,28.2,80.68,8.52,63.72-31.3,136.72-70.77,209.06-37.71,69.13-75.1,137.66-69.46,196.37,7.43,77.38,89.63,138.27,344.35,162.27,182.32,14.19,252.29,49.51,257.41,100.78C697.52,808.28,617,888.06,523.08,981c-37.75,37.39-77.66,76.92-115,118h-1.59c37.64-41.61,78-81.57,116.13-119.34C616.35,887,696.75,807.33,690.94,749.1c-5-50.37-74.76-85.16-256.59-99.31-255.25-24-337.66-85.53-345.17-163.74-5.71-59.4,31.79-128.13,69.61-197.46,39.35-72.12,79.05-144.89,70.63-207.86C225.57,51.91,215.45,25.16,201,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 546.07,
    y1: 1066.09,
    x2: 192.14,
    y2: -109.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.68,0C213.2,32.79,230,68.23,235.21,107.57c8.52,63.72-31.3,136.72-70.77,209.06C126.73,385.76,89.34,454.29,95,513c7.43,77.39,89.63,138.27,344.35,162.27C621.65,689.46,691.62,724.78,696.74,776c5.9,59.13-74.66,138.91-168.54,231.87-29.45,29.17-60.22,59.64-90,91.16h-1.64c30.19-32,61.4-62.89,91.26-92.45C621.47,913.84,701.87,834.22,696.06,776c-5-50.38-74.76-85.16-256.59-99.31-255.25-24-337.66-85.53-345.17-163.74-5.71-59.4,31.79-128.13,69.61-197.46,39.35-72.12,79.05-144.89,70.64-207.86C229.29,68.3,212.37,32.84,188.61,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 550.76,
    y1: 1064.68,
    x2: 196.84,
    y2: -110.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.6,0c34.47,40.18,60,84.13,66.74,134.46,8.51,63.72-31.31,136.72-70.77,209.06-37.72,69.13-75.11,137.66-69.47,196.37,7.43,77.38,89.63,138.27,344.35,162.27,182.33,14.19,252.29,49.51,257.41,100.77,5.91,59.13-74.66,138.91-168.54,231.87-21,20.79-42.65,42.25-64.16,64.27h-1.68c21.92-22.48,44-44.37,65.43-65.56C626.59,940.73,707,861.11,701.18,802.88c-5-50.37-74.76-85.16-256.59-99.31C189.35,679.52,106.93,618,99.42,539.83c-5.7-59.4,31.79-128.13,69.62-197.46,39.34-72.12,79.05-144.89,70.63-207.86C232.94,84.22,207.15,40.26,172.37,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 555.46,
    y1: 1063.26,
    x2: 201.53,
    y2: -111.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.9,0c46.7,47.39,83.29,99.55,91.56,161.35,8.51,63.72-31.31,136.72-70.77,209.05C137,439.54,99.58,508.07,105.22,566.78c7.43,77.38,89.63,138.27,344.36,162.27C631.9,743.24,701.86,778.56,707,829.82c5.91,59.12-74.66,138.91-168.53,231.87-12.36,12.24-25,24.7-37.6,37.38h-1.71c13.09-13.12,26.11-26,38.89-38.68C631.71,967.62,712.12,888,706.3,829.77c-5-50.38-74.76-85.16-256.59-99.31C194.47,706.4,112.05,644.93,104.54,566.71c-5.7-59.39,31.79-128.12,69.62-197.45,39.34-72.12,79.05-144.9,70.63-207.86C236.54,99.69,199.58,47.5,152.52,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 560.15,
    y1: 1061.85,
    x2: 206.23,
    y2: -113.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.06,0c59.52,54.55,109.66,114.54,119.52,188.24C259.1,252,219.27,325,179.81,397.29,142.09,466.42,104.7,535,110.34,593.67,117.78,671.05,200,731.93,454.7,755.94,637,770.13,707,805.45,712.1,856.71c5.91,59.13-74.66,138.91-168.53,231.87L533,1099.07h-1.72l11.9-11.79c93.68-92.77,174.09-172.39,168.27-230.62-5-50.38-74.76-85.16-256.59-99.31C199.59,733.29,117.17,671.82,109.66,593.6c-5.7-59.39,31.79-128.12,69.62-197.45,39.34-72.12,79-144.9,70.63-207.87C240.07,114.72,189.43,54.68,129.53,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 564.85,
    y1: 1060.43,
    x2: 210.92,
    y2: -114.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.75,0c72.09,61.79,138.45,129.13,150,215.13,8.52,63.72-31.31,136.72-70.77,209.05-37.72,69.13-75.1,137.67-69.47,196.38,7.44,77.38,89.64,138.27,344.36,162.27C642.14,797,712.1,832.34,717.22,883.6c5.56,55.62-65.41,129.52-152,215.47h-1.72c87-86.32,158.53-160.48,153-215.52-5-50.38-74.76-85.16-256.58-99.31-255.25-24.06-337.67-85.53-345.18-163.75-5.7-59.39,31.8-128.12,69.62-197.45,39.35-72.12,79-144.9,70.63-207.86C243.56,129.37,176.58,62,104.12,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 567.11,
    y1: 1059.75,
    x2: 213.19,
    y2: -115.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.92,0c83.38,69.32,168.71,143.4,181.9,242,8.52,63.72-31.3,136.71-70.77,209.05C152.33,520.2,115,588.73,120.59,647.45c7.43,77.38,89.63,138.26,344.35,162.27,182.32,14.19,252.29,49.51,257.41,100.77,5,49.73-51.25,114.07-125.09,188.58h-1.7c74.28-74.85,131-139.39,126.11-188.63-5-50.38-74.76-85.16-256.59-99.31C209.83,787.07,127.42,725.6,119.9,647.38c-5.7-59.39,31.8-128.12,69.62-197.45,39.35-72.12,79-144.9,70.63-207.87C247,143.71,160.91,69.52,77.25,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 556.87,
    y1: 1062.84,
    x2: 202.95,
    y2: -112.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.72,0Q62.94,9.39,74.38,18.86c86.33,71.65,177.87,147.62,191.56,250.05,8.52,63.72-31.3,136.71-70.77,209-37.71,69.13-75.1,137.66-69.46,196.37,7.43,77.39,89.63,138.27,344.35,162.28,182.32,14.19,252.29,49.5,257.41,100.77,4.36,43.64-38.41,98.54-98.85,161.69H627c60.91-63.46,104.15-118.5,99.83-161.75C721.76,887,652,852.17,470.2,838,215,814,132.54,752.49,125,674.27c-5.71-59.39,31.79-128.12,69.61-197.45C234,404.7,273.69,331.92,265.27,269,251.7,167.41,160.38,91.63,74.26,20.15,66.13,13.4,58,6.69,50.07,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 546.48,
    y1: 1065.97,
    x2: 192.55,
    y2: -109.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.45,0C42.68,15.2,61,30.37,79.5,45.75,165.83,117.4,257.37,193.37,271.06,295.8c8.52,63.72-31.3,136.71-70.77,209.05-37.71,69.13-75.1,137.66-69.46,196.37,7.43,77.39,89.63,138.27,344.35,162.28C657.5,877.69,727.47,913,732.59,964.27c3.73,37.32-27,82.89-73.81,134.8h-1.57c47.25-52.18,78.39-97.84,74.7-134.86-5-50.37-74.76-85.15-256.59-99.3-255.25-24.06-337.66-85.53-345.17-163.75-5.71-59.39,31.79-128.12,69.61-197.45,39.35-72.12,79.05-144.9,70.63-207.87C256.82,194.3,165.51,118.52,79.38,47c-19-15.81-37.85-31.41-55.5-47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 536.53,
    y1: 1068.96,
    x2: 182.61,
    y2: -106.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.43,0C26.35,24.28,55.18,48.21,84.62,72.64,171,144.29,262.49,220.26,276.18,322.69c8.52,63.72-31.3,136.71-70.77,209.05C167.7,600.87,130.31,669.4,136,728.11c7.43,77.39,89.63,138.27,344.35,162.28,182.33,14.19,252.29,49.5,257.41,100.77,3.07,30.73-17.24,67.06-50.63,107.91h-1.44c33.8-41.07,54.44-77.46,51.39-108-5-50.37-74.76-85.15-256.59-99.3-255.25-24.06-337.66-85.54-345.17-163.75-5.71-59.39,31.79-128.12,69.61-197.46,39.35-72.11,79.05-144.89,70.63-207.86-13.57-101.54-104.88-177.32-191-248.8C54.55,49.08,25.23,24.74,0,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 527.63,
    y1: 1071.64,
    x2: 173.71,
    y2: -103.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1843.31,0c30.72,57.77,56.4,114.08,51.66,163.44-7.44,77.39-89.64,138.27-344.36,162.28-182.32,14.18-252.29,49.5-257.4,100.77-5.91,59.12,74.66,138.9,168.53,231.86,128.09,126.85,281,278.27,272.38,433.9q-.18,3.42-.45,6.82h.68q.27-3.49.47-7c8.65-156.43-144.43-308-272.66-435-93.69-92.78-174.09-172.4-168.27-230.63,5-50.37,74.76-85.16,256.58-99.31,255.25-24.05,337.66-85.53,345.18-163.74,4.76-49.64-20.65-105.8-51.2-163.38Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1340.8,
    y1: 1034.56,
    x2: 1873.21,
    y2: 14.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020c6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1823.67,0c36.57,67.07,71.65,133.33,66.17,190.33-7.43,77.39-89.63,138.27-344.35,162.28-182.32,14.18-252.29,49.5-257.41,100.76-5.9,59.13,74.67,138.91,168.54,231.87,122.58,121.39,267.86,265.28,272.59,413.83h.7C1725.39,949.71,1579.83,805.55,1457,684c-93.69-92.78-174.09-172.4-168.28-230.63,5-50.37,74.76-85.16,256.59-99.31C1800.6,330,1883,268.48,1890.53,190.27c5.5-57.34-29.26-123.39-65.7-190.27Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1337.06,
    y1: 1032.61,
    x2: 1869.48,
    y2: 12.17,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1803.92,0q5.64,10.43,11.34,20.85c37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.38-89.63,138.27-344.35,162.27C1358.05,393.68,1288.08,429,1283,480.26c-5.9,59.13,74.66,138.91,168.54,231.87,115.16,114,250.37,248,270.22,386.94h.76c-19.65-139.73-155.16-273.95-270.56-388.23-93.69-92.78-174.09-172.4-168.28-230.63,5-50.37,74.76-85.16,256.59-99.31,255.25-24,337.66-85.53,345.17-163.74,5.71-59.4-31.79-128.13-69.61-197.46q-5.38-9.84-10.72-19.7Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1333.11,
    y1: 1030.55,
    x2: 1865.53,
    y2: 10.11,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1784.55,0c8.2,15.87,16.9,31.82,25.59,47.74,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.38-89.63,138.27-344.35,162.27-182.33,14.19-252.29,49.51-257.41,100.77-5.9,59.13,74.66,138.91,168.54,231.87,107.72,106.67,233,230.73,265,360h.83c-31.8-130-157.4-254.41-265.39-361.35C1353.11,645,1272.71,565.33,1278.52,507.1c5-50.38,74.76-85.16,256.59-99.31,255.25-24.05,337.66-85.53,345.17-163.75,5.71-59.39-31.79-128.12-69.61-197.45-8.48-15.53-17-31.1-25-46.59Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1329.09,
    y1: 1028.45,
    x2: 1861.5,
    y2: 8.01,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1766.07,0c11.7,24.68,25.34,49.69,39,74.62,37.71,69.14,75.1,137.67,69.46,196.38-7.43,77.38-89.63,138.27-344.35,162.27C1347.8,447.46,1277.84,482.78,1272.72,534c-5.91,59.12,74.66,138.91,168.54,231.87,100.23,99.26,215.65,213.56,257,333.16h.9c-41.19-120.25-157-234.91-257.48-334.46C1348,671.84,1267.58,592.22,1273.4,534c5-50.38,74.76-85.16,256.59-99.31,255.25-24.06,337.66-85.53,345.17-163.75,5.7-59.39-31.79-128.12-69.62-197.45-13.39-24.55-26.83-49.19-38.39-73.48Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1325.06,
    y1: 1026.35,
    x2: 1857.48,
    y2: 5.91,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1749,0c13.66,33.29,32.3,67.48,50.87,101.51,37.72,69.14,75.11,137.67,69.47,196.38-7.43,77.38-89.63,138.27-344.36,162.27-182.32,14.19-252.28,49.51-257.4,100.77-5.91,59.13,74.66,138.91,168.53,231.87,92.7,91.79,198.37,196.46,246.44,306.27h1c-48-110.44-154-215.47-247-307.57-93.68-92.77-174.09-172.39-168.27-230.62,5-50.38,74.76-85.16,256.59-99.31C1780.11,437.51,1862.53,376,1870,297.82c5.7-59.39-31.79-128.12-69.62-197.45C1782.05,66.7,1763.61,32.89,1750,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1321.04,
    y1: 1024.25,
    x2: 1853.45,
    y2: 3.81,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1734,0c13.44,41.62,37.17,85.13,60.78,128.4,37.72,69.13,75.11,137.67,69.47,196.38-7.43,77.38-89.63,138.26-344.36,162.27-182.32,14.19-252.28,49.51-257.4,100.77-5.91,59.12,74.66,138.91,168.53,231.87,85.1,84.27,181.14,179.39,233.5,279.38h1.09C1613.28,998.49,1516.85,903,1431.43,818.39c-93.68-92.77-174.09-172.39-168.27-230.62,5-50.38,74.76-85.16,256.58-99.31,255.25-24.06,337.67-85.53,345.18-163.75,5.7-59.39-31.79-128.12-69.62-197.45-23.42-42.92-47-86.08-60.41-127.26Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1317.01,
    y1: 1022.15,
    x2: 1849.43,
    y2: 1.71,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1721.67,0c10.3,49.55,39.23,102.6,68,155.29,37.72,69.13,75.1,137.66,69.47,196.38-7.44,77.38-89.64,138.26-344.36,162.27-182.32,14.19-252.28,49.51-257.4,100.77-5.91,59.12,74.66,138.91,168.53,231.87,77.44,76.68,163.93,162.35,218.34,252.49h1.18c-54.43-90.71-141.33-176.77-219.1-253.79-93.69-92.77-174.09-172.4-168.27-230.62,5-50.38,74.76-85.16,256.58-99.31,255.25-24.06,337.67-85.53,345.18-163.75,5.7-59.39-31.8-128.12-69.62-197.45C1761.61,101.77,1732.85,49.06,1722.47,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1312.99,
    y1: 1020.05,
    x2: 1845.4,
    y2: -0.39,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1712.87,0c3.35,57,37.64,119.82,71.66,182.18,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.39-89.63,138.28-344.35,162.28-182.32,14.19-252.29,49.51-257.4,100.77-5.91,59.12,74.66,138.91,168.53,231.87,69.7,69,146.73,145.31,201.11,225.6h1.28c-54.47-80.83-131.92-157.53-202-226.9-93.69-92.77-174.09-172.4-168.28-230.62,5-50.38,74.77-85.16,256.59-99.31,255.25-24.06,337.66-85.53,345.18-163.75,5.7-59.39-31.8-128.12-69.62-197.45-33.87-62.09-68-124.66-71.48-181Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1308.96,
    y1: 1017.95,
    x2: 1841.38,
    y2: -2.49,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1708.64,0V0c-8.52,63.72,31.3,136.71,70.77,209.05,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.39-89.63,138.27-344.35,162.28-182.32,14.19-252.29,49.5-257.41,100.77-5.9,59.12,74.67,138.9,168.54,231.87,61.87,61.26,129.53,128.27,182,198.71H1599c-52.61-71-120.69-138.38-182.92-200-93.69-92.77-174.09-172.4-168.28-230.63,5-50.37,74.76-85.15,256.59-99.31,255.25-24,337.66-85.52,345.17-163.74,5.71-59.39-31.79-128.12-69.61-197.45-39.35-72.12-79-144.9-70.63-207.87V0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1304.94,
    y1: 1015.85,
    x2: 1837.35,
    y2: -4.59,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1709,0a203.5,203.5,0,0,0-5.5,26.9c-8.52,63.73,31.3,136.72,70.77,209.06,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.39-89.63,138.27-344.35,162.28-182.32,14.19-252.29,49.5-257.41,100.77-5.9,59.12,74.66,138.9,168.54,231.86,54,53.43,112.3,111.21,161.13,171.83h1.44C1524,1038,1465.27,979.74,1411,926c-93.69-92.78-174.09-172.4-168.28-230.63,5-50.37,74.76-85.16,256.59-99.31,255.25-24,337.66-85.53,345.17-163.74,5.71-59.39-31.79-128.12-69.61-197.45-39.35-72.13-79-144.9-70.63-207.87A199.27,199.27,0,0,1,1709.73,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1300.91,
    y1: 1013.74,
    x2: 1833.32,
    y2: -6.69,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1713.27,0a209.13,209.13,0,0,0-14.87,53.79c-8.52,63.73,31.3,136.72,70.77,209.06,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.39-89.63,138.27-344.35,162.28C1312,635.69,1242,671,1236.87,722.27c-5.9,59.12,74.66,138.9,168.54,231.86,45.91,45.47,95,94.1,138.72,144.94h1.52c-44-51.33-93.53-100.38-139.83-146.23-93.68-92.78-174.09-172.4-168.27-230.63,5-50.37,74.76-85.15,256.59-99.3,255.25-24.06,337.66-85.54,345.17-163.75,5.71-59.39-31.79-128.12-69.62-197.46-39.34-72.12-79-144.89-70.62-207.86a206.76,206.76,0,0,1,15-53.84Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1296.89,
    y1: 1011.64,
    x2: 1829.3,
    y2: -8.79,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1721.48,0c-14.33,25.13-24.35,51.86-28.2,80.68-8.52,63.72,31.3,136.72,70.77,209.06,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.38-89.63,138.27-344.35,162.27-182.33,14.19-252.29,49.51-257.41,100.78-5.91,59.12,74.66,138.9,168.54,231.86,37.75,37.39,77.66,76.92,115,118h1.59c-37.63-41.61-78-81.57-116.13-119.34C1307,887,1226.61,807.33,1232.43,749.1c5-50.37,74.76-85.16,256.59-99.31,255.24-24,337.66-85.53,345.17-163.74,5.71-59.4-31.79-128.13-69.62-197.46-39.34-72.12-79-144.89-70.63-207.86,3.86-28.82,14-55.57,28.46-80.73Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1292.86,
    y1: 1009.54,
    x2: 1825.27,
    y2: -10.89,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1733.69,0c-23.52,32.79-40.28,68.23-45.54,107.57-8.52,63.72,31.31,136.72,70.77,209.06,37.72,69.13,75.11,137.66,69.47,196.37C1821,590.39,1738.76,651.27,1484,675.27c-182.32,14.19-252.28,49.51-257.4,100.77-5.91,59.13,74.66,138.91,168.54,231.87,29.45,29.17,60.22,59.64,90,91.16h1.64c-30.2-32-61.4-62.89-91.26-92.45-93.68-92.78-174.09-172.4-168.27-230.63,5-50.38,74.76-85.16,256.59-99.31,255.24-24,337.66-85.53,345.17-163.74,5.7-59.4-31.79-128.13-69.62-197.46-39.34-72.12-79-144.89-70.63-207.86C1694.08,68.3,1711,32.84,1734.76,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1288.83,
    y1: 1007.44,
    x2: 1821.25,
    y2: -12.99,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1749.77,0c-34.47,40.18-60,84.13-66.74,134.46-8.52,63.72,31.31,136.72,70.77,209.06,37.72,69.13,75.11,137.66,69.47,196.37-7.43,77.38-89.63,138.27-344.36,162.27-182.32,14.19-252.28,49.51-257.4,100.77-5.91,59.13,74.66,138.91,168.53,231.87,21,20.79,42.66,42.25,64.17,64.27h1.68c-21.92-22.48-44-44.37-65.43-65.56-93.68-92.78-174.09-172.4-168.27-230.63,5-50.37,74.76-85.16,256.58-99.31C1734,679.52,1816.44,618,1824,539.83c5.7-59.4-31.79-128.13-69.62-197.46-39.34-72.12-79-144.89-70.63-207.86C1690.42,84.22,1716.22,40.26,1751,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1284.81,
    y1: 1005.34,
    x2: 1817.22,
    y2: -15.1,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1769.46,0c-46.69,47.39-83.29,99.55-91.55,161.35-8.52,63.72,31.3,136.72,70.77,209.05,37.72,69.14,75.1,137.67,69.47,196.38-7.44,77.38-89.64,138.27-344.36,162.27-182.32,14.19-252.28,49.51-257.4,100.77-5.91,59.12,74.66,138.91,168.53,231.87,12.36,12.24,24.95,24.7,37.6,37.38h1.71c-13.09-13.12-26.11-26-38.89-38.68-93.68-92.77-174.09-172.39-168.27-230.62,5-50.38,74.76-85.16,256.58-99.31,255.25-24.06,337.67-85.53,345.18-163.75,5.7-59.39-31.8-128.12-69.62-197.45-39.35-72.12-79-144.9-70.63-207.86,8.25-61.71,45.21-113.9,92.27-161.4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1280.78,
    y1: 1003.24,
    x2: 1813.2,
    y2: -17.19,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1792.31,0c-59.52,54.55-109.67,114.54-119.52,188.24-8.52,63.72,31.3,136.71,70.77,209.05,37.71,69.13,75.1,137.67,69.46,196.38-7.43,77.38-89.63,138.26-344.35,162.27-182.32,14.19-252.29,49.51-257.4,100.77-5.91,59.13,74.66,138.91,168.53,231.87l10.59,10.49h1.73l-11.9-11.79c-93.69-92.77-174.09-172.39-168.28-230.62,5-50.38,74.76-85.16,256.59-99.31,255.25-24.06,337.66-85.53,345.18-163.75,5.7-59.39-31.8-128.12-69.62-197.45-39.35-72.12-79-144.9-70.63-207.87,9.83-73.56,60.47-133.6,120.38-188.28Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1276.76,
    y1: 1001.14,
    x2: 1809.17,
    y2: -19.3,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1817.62,0c-72.09,61.79-138.45,129.13-149.95,215.13-8.52,63.72,31.3,136.72,70.77,209.05,37.71,69.13,75.1,137.67,69.46,196.38-7.43,77.38-89.63,138.27-344.35,162.27C1281.23,797,1211.26,832.34,1206.14,883.6c-5.55,55.62,65.42,129.52,152,215.47h1.72c-87-86.32-158.53-160.48-153-215.52,5-50.38,74.76-85.16,256.59-99.31,255.25-24.06,337.66-85.53,345.17-163.75,5.71-59.39-31.79-128.12-69.61-197.45-39.35-72.12-79-144.9-70.63-207.86C1679.81,129.37,1746.79,62,1819.24,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1274.82,
    y1: 1000.13,
    x2: 1807.23,
    y2: -20.31,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1844.45,0c-83.38,69.32-168.72,143.4-181.9,242-8.52,63.72,31.3,136.71,70.77,209.05,37.71,69.13,75.1,137.66,69.46,196.38-7.43,77.38-89.63,138.26-344.35,162.27-182.32,14.19-252.29,49.51-257.41,100.77-5,49.73,51.25,114.07,125.09,188.58h1.7c-74.28-74.85-131-139.39-126.11-188.63,5-50.38,74.76-85.16,256.59-99.31,255.25-24.06,337.66-85.53,345.17-163.75,5.71-59.39-31.79-128.12-69.61-197.45-39.35-72.12-79-144.9-70.63-207.87,13.15-98.35,99.24-172.54,182.9-242.06Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1283.6,
    y1: 1004.71,
    x2: 1816.01,
    y2: -15.73,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1871.64,0Q1860.44,9.39,1849,18.86c-86.33,71.65-177.87,147.62-191.56,250.05-8.52,63.72,31.3,136.71,70.77,209,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.39-89.63,138.27-344.35,162.28C1271,850.8,1201,886.11,1195.9,937.38c-4.36,43.64,38.4,98.54,98.85,161.69h1.65c-60.9-63.46-104.14-118.5-99.82-161.75,5-50.37,74.76-85.15,256.59-99.31,255.25-24,337.66-85.52,345.17-163.74,5.71-59.39-31.79-128.12-69.61-197.45-39.35-72.12-79-144.9-70.63-207.87,13.57-101.54,104.88-177.32,191-248.8,8.13-6.75,16.22-13.46,24.19-20.15Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1292.51,
    y1: 1009.36,
    x2: 1824.92,
    y2: -11.08,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1897.91,0c-17.22,15.2-35.51,30.37-54,45.75C1757.53,117.4,1666,193.37,1652.31,295.8c-8.52,63.72,31.3,136.71,70.77,209.05,37.71,69.13,75.1,137.66,69.46,196.37-7.43,77.39-89.63,138.27-344.35,162.28-182.33,14.19-252.29,49.5-257.41,100.77-3.73,37.32,27,82.89,73.81,134.8h1.56c-47.24-52.18-78.39-97.84-74.69-134.86,5-50.37,74.76-85.15,256.59-99.3,255.25-24.06,337.66-85.53,345.17-163.75,5.7-59.39-31.79-128.12-69.62-197.45-39.34-72.12-79-144.9-70.63-207.87C1666.55,194.3,1757.86,118.52,1844,47c19-15.81,37.85-31.41,55.5-47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1301.04,
    y1: 1013.81,
    x2: 1833.45,
    y2: -6.63,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1921.93,0c-24.91,24.28-53.74,48.21-83.18,72.64-86.34,71.65-177.87,147.62-191.57,250.05-8.52,63.72,31.31,136.71,70.77,209.05,37.72,69.13,75.11,137.66,69.47,196.37-7.43,77.39-89.63,138.27-344.36,162.28-182.32,14.19-252.28,49.5-257.4,100.77-3.07,30.73,17.24,67.06,50.63,107.91h1.44c-33.81-41.07-54.44-77.46-51.39-108,5-50.37,74.76-85.15,256.59-99.3,255.24-24.06,337.66-85.54,345.17-163.75,5.7-59.39-31.79-128.12-69.62-197.46-39.34-72.11-79-144.89-70.63-207.86,13.58-101.54,104.89-177.32,191-248.8,29.94-24.85,59.27-49.19,84.5-73.93Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1308.67,
    y1: 1017.79,
    x2: 1841.08,
    y2: -2.65,
    xlinkHref: "#linear-gradient-23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 22.96,
    width: 613.11,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 27.34,
    width: 613.85,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 32.26,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 37.38,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 42.5,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 47.62,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 52.75,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 57.87,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 62.99,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 68.11,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 73.23,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 78.35,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 83.47,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 88.59,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 93.72,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 98.84,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 103.96,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 104.12,
    width: 618.65,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 77.25,
    width: 650.06,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 50.07,
    width: 681.76,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 23.88,
    width: 712.44,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    width: 740.78,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1287.3,
    width: 613.11,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1282.18,
    width: 613.85,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1277.06,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1271.94,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1266.81,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1261.69,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1256.57,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1251.45,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1246.33,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1241.21,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1236.09,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1230.97,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1225.84,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1220.72,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 1215.6,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1210.48,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1205.36,
    width: 614.05,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1200.59,
    width: 618.65,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1196.06,
    width: 650.06,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1191.54,
    width: 681.76,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1187.05,
    width: 712.44,
    height: 1099.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1182.59,
    width: 740.78,
    height: 1099.07
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMesh);
export default __webpack_public_path__ + "static/media/FooterMesh.d32ffac00a0e67093bff1b390305d5fb.svg";
export { ForwardRef as ReactComponent };